// extracted by mini-css-extract-plugin
module.exports = {"box":"RatingBox_box__12-Rg","img":"RatingBox_img__jW-zf","bigNumber":"RatingBox_bigNumber__1Au3V","star":"RatingBox_star__20nt-"};